import axios from 'axios'
import create from 'zustand'
import { config } from '../config'

const useForm = create((set, get) => ({
  view: "TelaInicio",
  unidade: null,
  curso: null,
  reclamacao: null,
  nome: null,
  whatsapp: null,
  isLoading: false,
  setUnidade: (unidade) => set({ unidade, view: "TelaReclamacao"  }),
  setObrigado: (reclamacao, curso) => set({ reclamacao, curso, view: "TelaObrigado" }),
  setView: (view) => set({ view }),
  sendForm: async (nome, whatsapp, email) => {
     var data = {
      unidade: get().unidade,
      setor: null,
      curso: get().curso,
      reclamacao: get().reclamacao,
      nome,
      whatsapp,
      email,
      isToProfessor: true
    }
    set({ isLoading: true })
    
    try {
      await axios({
        method: 'POST',
        url: `${config.URL}/form`,
        headers: { 'Content-Type': 'application/json' },
        data
      })
      set({ isLoading: false })
    } catch (error) {
      set({ isLoading: false })
      console.log(error)
    }
  },
}))

export default useForm